import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { VrboService } from '@app/_services/vrbo.service';

@Component({
    selector: 'app-vrbo-review-respond',
    templateUrl: './vrbo-review-respond.component.html',
    styleUrls: ['./vrbo-review-respond.component.css'],
    standalone: false
})
export class VRBOReviewRespondComponent implements OnInit {
  form: UntypedFormGroup;
  reviewId: string;
  shortTermRentalId: number;
  submitting = false;

  localeOptions = [
    { label: 'English (US)', value: 'en-US' },
    { label: 'English (GB)', value: 'en-GB' },
    { label: 'Spanish', value: 'es-ES' },
    { label: 'French', value: 'fr-FR' },
    { label: 'German', value: 'de-DE' },
    { label: 'Japanese', value: 'ja-JP' }
  ];

  constructor(
    private fb: UntypedFormBuilder,
    private dynamicDialogRef: DynamicDialogRef,
    private dynamicDialogConfig: DynamicDialogConfig,
    private messageService: MessageService,
    private vrboService: VrboService
  ) {}

  ngOnInit(): void {
    this.reviewId = this.dynamicDialogConfig.data?.reviewId;
    this.shortTermRentalId = this.dynamicDialogConfig.data?.shortTermRentalId;
    this.buildForm();
  }

  buildForm(): void {
    this.form = this.fb.group({
      responseText: ['', [Validators.required, Validators.minLength(10)]],
      locale: ['en-US']
    });
  }

  submit(): void {
    if (this.form.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Validation', detail: 'Please enter a response (minimum 10 characters).' });
      return;
    }

    this.submitting = true;
    const { responseText, locale } = this.form.value;

    this.vrboService.respondToReview(this.reviewId, this.shortTermRentalId, responseText, locale).subscribe(
      (res: any) => {
        this.submitting = false;
        if (res?.statusCode === 200) {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Response submitted successfully to VRBO.' });
          this.dynamicDialogRef.close({ action: 'RESPONDED' });
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: res?.message || 'Failed to submit response.' });
        }
      },
      (err: any) => {
        this.submitting = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.message || err?.message || 'Failed to submit response.' });
      }
    );
  }

  cancel(): void {
    this.dynamicDialogRef.close();
  }
}
